// ** React Import
import { useState } from 'react';

// ** Custom Components
import Sidebar from '@components/sidebar';
import ToastError from '@components/toast/ToastError';

// ** Third Party Components
import toast from 'react-hot-toast';
import FileUploaderSingle from '@components/input/FileUploaderSingle';
import { DownloadCloud } from 'react-feather';

// ** Reactstrap Imports
import { Button, Label, Form } from 'reactstrap';
import api from '../../../graphql/api';
import { useForm } from 'react-hook-form';

const FormSidebar = ({ open, toggleSidebar, handleFetch }) => {
  const [progress, setProgress] = useState({
    per: 0,
    text: '0%',
    started: false
  });
  const { handleSubmit, setValue, getValues } = useForm({
    defaultValues: {
      filename: '',
      uri: ''
    }
  });
  // ** States
  const handleSidebarClosed = () => {};

  const handleImageSubmit = async (files) => {
    try {
      const data = new FormData();
      data.append('file', files[0]);
      const config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          const text = `${percentCompleted}%`;
          setProgress({
            per: percentCompleted,
            text,
            started: true
          });
        }
      };
      const res = (await api.post('/phrase-design/file-upload', data, config))
        .data;
      setValue('filename', res.name);
      setValue('uri', res.uri);
    } catch (e) {
      const errors = e.graphQLErrors;
      errors?.forEach((error) => {
        const message =
          error?.extensions?.exception?.response?.es ||
          error?.extensions?.response?.message[0];
        toast((t) => <ToastError t={t} message={message} />);
      });
    }
  };

  const onSubmit = async () => {
    const data = {
      filename: getValues('filename'),
      uri: getValues('uri')
    };
    await api.post('/phrase-design/add', data);
    setProgress({
      per: 0,
      text: '0%',
      started: false
    });
    handleFetch();
  };

  return (
    <Sidebar
      size="lg"
      open={open}
      title="Crear Carátula nueva"
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={toggleSidebar}
      onClosed={handleSidebarClosed}
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-1">
          <Label className="form-label" for="image">
            Image <span className="text-danger">*</span>
          </Label>
          <FileUploaderSingle
            handleSubmit={handleImageSubmit}
            accept=".jpg,.png,.jpeg"
          >
            <div
              className="px-5 py-2 d-flex align-items-center justify-content-center flex-column mb-1 position-relative"
              style={{
                border: '1px dashed #7367F0',
                borderRadius: '2.5px'
              }}
            >
              <DownloadCloud size={64} />
              <p className="text-secondary">
                Suelta archivos aca o{' '}
                <a href="/" onClick={(e) => e.preventDefault()}>
                  navega
                </a>
              </p>
              {progress.started && (
                <div
                  className="progress position-absolute"
                  style={{ width: '100%', height: 15, bottom: 0 }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      background: '#4DFF84',
                      width: `${progress.text}`
                    }}
                    aria-valuenow={progress.per}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    {progress.text}
                  </div>
                </div>
              )}
            </div>
          </FileUploaderSingle>
        </div>

        <div
          style={{
            fontWeight: 'bold',
            fontSize: 16
          }}
        >
          Tamaño recomendado: 1000x1000
        </div>
        <Button className="me-1 mt-1" color="primary" type="submit">
          Crear
        </Button>
        <Button
          className="mt-1"
          variant="outline-dark"
          outline
          onClick={() => toggleSidebar()}
        >
          Cancelar
        </Button>
      </Form>
    </Sidebar>
  );
};

export default FormSidebar;
